@if (params().showSeries) {
  <div class="legend">
    @for (item of legendItems(); track item.color) {
      <div
        class="legend-item"
        [class.legend-item--hidden]="isSeriesHidden(item.name)"
        (click)="onLegendClick(item.name)"
      >
        <span
          class="legend-swatch"
          [style.background-color]="isSeriesHidden(item.name) ? 'var(--neutral-300)' : item.color"
        ></span>
        <span [innerHTML]="item.html"></span>
      </div>
    }
  </div>
}
<div
  echarts
  class="chart"
  [style.--chart-height.px]="height()"
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
  (chartInit)="onChartInit($event)"
></div>
@if (!hasDataZoom() && !params().xAxisLabelTemplate) {
  <div class="x-axis-labels" [style.padding-left.px]="gridLeft" [style.padding-right.px]="gridRight">
    @for (html of xLabelHtmls(); track $index) {
      <span class="x-label" [innerHTML]="html"></span>
    }
  </div>
}
@if (params().showSliders) {
  <div class="sliders-panel">
    <dojo-slider
      [param]="resolvedLabels().firstTermLabel"
      [min]="sliderConfig().firstTerm.min"
      [max]="sliderConfig().firstTerm.max"
      [step]="sliderConfig().firstTerm.step"
      [value]="effectiveFirstTerm()"
      [editable]="true"
      color="pink"
      (valueChange)="onFirstTermChange($event)"
    />
    <dojo-slider
      [param]="resolvedLabels().commonFactorLabel"
      [min]="sliderConfig().commonFactor.min"
      [max]="sliderConfig().commonFactor.max"
      [step]="sliderConfig().commonFactor.step"
      [value]="effectiveCommonFactor()"
      [editable]="true"
      color="sky"
      (valueChange)="onCommonFactorChange($event)"
    />
  </div>
}
